import { ValuationsApproach } from 'common/types/valuation';
import { ReverseParsedValuationApproachGPT } from 'pages/ValuationsAllocation/approaches/TransactionComps/types';
import { VALUATIONS_BENCHMARK_RELATED_APPROACHES_TYPES } from 'pages/ValuationsAllocation/common/constants/valuations';
import { BenchmarkApproach } from 'pages/ValuationsAllocation/util/getSelectionCellOptions';
import { getStringValue } from 'utilities';

type ExtractableApproach =
  | ValuationsApproach
  | {
      valuations_approach_gpt: ReverseParsedValuationApproachGPT;
    };

const extractSpecificApproachFromApproach = (approach?: ExtractableApproach) => {
  const approachType =
    approach && 'approach_type' in approach ? approach.approach_type : undefined;
  const approachProperty = VALUATIONS_BENCHMARK_RELATED_APPROACHES_TYPES.get(
    getStringValue(approachType)
  ) as keyof ValuationsApproach;

  return (approach as ValuationsApproach)?.[approachProperty] as BenchmarkApproach;
};

export default extractSpecificApproachFromApproach;
